module.exports = __webpack_public_path__ + "img/tcbiopharm.eae7b542.png";